import { render, staticRenderFns } from "./SpaceConfigurationCreditQuotas.vue?vue&type=template&id=b4237ee8&"
import script from "./SpaceConfigurationCreditQuotas.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationCreditQuotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports